import {useEffect, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchContainerDetails, selectContainerShipping} from "../redux/slices/container_details";
import {groupShipping} from "../utils/inventory";


export default function useContainerDetails(containerRef) {
    const code = useMemo(() => containerRef, [containerRef])
    const dispatch = useDispatch();
    
    const {byCode = {}, loading = false, notExist = [], hasQueried = []} = useSelector(selectContainerShipping);
    const data = useMemo(() => byCode[code] || [], [byCode, code]);
    const grouped = useMemo(() => groupShipping(data), [data]);

    useEffect(() => {
        if (!loading && !hasQueried.includes(code) && !notExist.includes(code)) {
            dispatch(fetchContainerDetails(code))
        }
    }, [code, dispatch, hasQueried, loading, notExist]);
    
    return {data, grouped, loading}
}